"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storageService = exports.dbService = exports.authService = void 0;
var app_1 = __importDefault(require("firebase/compat/app"));
require("firebase/compat/auth");
require("firebase/compat/storage");
require("firebase/compat/firestore");
var projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
var firebaseConfig = {
    projectId: projectId,
    authDomain: "".concat(projectId, ".firebaseapp.com"),
    databaseURL: "https://".concat(projectId, ".firebaseio.com"),
    storageBucket: "".concat(projectId, ".appspot.com"),
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
};
app_1.default.initializeApp(firebaseConfig);
app_1.default.firestore().settings({
    ignoreUndefinedProperties: true
});
exports.default = app_1.default;
exports.authService = app_1.default.auth();
exports.dbService = app_1.default.firestore();
exports.storageService = app_1.default.storage();
//# sourceMappingURL=fbase.js.map